import { Directive, ElementRef, Host, HostBinding, HostListener, Optional, SkipSelf } from '@angular/core';
import { AutocompleteOptionGroupComponent } from '../components/autocomplete-option-group/autocomplete-option-group.component';

@Directive({
  selector: '[app-autocomplete-option]',
})
export class AutocompleteOptionDirective {
  static nextId = 0;
  readonly id = `app-autocomplete-option-${AutocompleteOptionDirective.nextId++}`;

  @HostBinding('class') class =
    'block cursor-default px-4 py-2 text-sm select-none focus:outline-hidden aria-selected:bg-indigo-600 aria-selected:text-white';
  @HostBinding('role') role = 'option';
  @HostBinding('attr.id') attrId = this.id;
  @HostBinding('attr.aria-selected') attrAriaSelected = false;

  @HostListener('mouseenter') onMouseEnter() {
    this.parent.setOptionActive(this);
  }

  @HostListener('click') onClick() {
    this.parent.selectOption(this);
  }

  constructor(
    public el: ElementRef<HTMLElement>,
    @Optional() @Host() @SkipSelf() private parent: AutocompleteOptionGroupComponent
  ) {}

  get value() {
    // TODO remove
    return this.el.nativeElement.textContent;
  }
}
